<template>
  <v-app
    v-bind:class="[
      $vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl
        ? 'fill-height'
        : '',
    ]"
  >
    <v-container
      fluid
      class="no-padding"
      v-bind:class="[
        $vuetify.breakpoint.md ||
        $vuetify.breakpoint.lg ||
        $vuetify.breakpoint.xl
          ? 'fill-height'
          : '',
      ]"
    >
      <v-row
        v-bind:class="[
          $vuetify.breakpoint.md ||
          $vuetify.breakpoint.lg ||
          $vuetify.breakpoint.xl
            ? 'fill-height'
            : '',
        ]"
      >
        <v-col
          md="12"
          class="no-padding"
          v-bind:class="[
            $vuetify.breakpoint.md ||
            $vuetify.breakpoint.lg ||
            $vuetify.breakpoint.xl
              ? 'fill-height'
              : '',
          ]"
        >
          <form
            ref="form"
            @submit.prevent="bookNow"
            class="no-padding"
            v-bind:class="[
              $vuetify.breakpoint.md ||
              $vuetify.breakpoint.lg ||
              $vuetify.breakpoint.xl
                ? 'fill-height'
                : '',
            ]"
          >
            <div v-if="loadingTarifas" class="ui active inverted dimmer">
              <div class="ui text loader">Loading TeeSheet</div>
            </div>
            <!-- Seccion de datos fecha reserva -->
            <v-row
              v-bind:class="[
                $vuetify.breakpoint.md ||
                $vuetify.breakpoint.lg ||
                $vuetify.breakpoint.xl
                  ? 'fill-height'
                  : '',
              ]"
            >
              <!-- Seccion  fecha reserva y Jugadores -->
              <v-col cols="12" md="4" lg="3" class="pa-7 fill-height" dark>
                <h4 class="light-blue--text text--darken-4">
                  1. Selecione tipo de juego
                </h4>
                <!-- number players -->
                <v-row v-if="false" class="mb-4 mt-4 px-3">
                  <v-card
                    v-bind:class="[
                      playersNumber == '1' ? 'teal accent-4' : 'btn-unSelected',
                    ]"
                    class="col-md-3 col-3 pa-2 btnGrpStart"
                    dark
                    @click="
                      playersNumber = '1';
                      changePlayersNumber();
                    "
                  >
                    1 Player
                  </v-card>
                  <v-card
                    v-bind:class="[
                      playersNumber == '2' ? 'teal accent-4' : 'btn-unSelected',
                    ]"
                    class="col-md-3 col-3 pa-2 btnGrpMiddle"
                    dark
                    @click="
                      playersNumber = '2';
                      changePlayersNumber();
                    "
                  >
                    2 Players
                  </v-card>
                  <v-card
                    v-bind:class="[
                      playersNumber == '3' ? 'teal accent-4' : 'btn-unSelected',
                    ]"
                    class="col-md-3 col-3 pa-2 btnGrpMiddle"
                    dark
                    @click="
                      playersNumber = '3';
                      changePlayersNumber();
                    "
                  >
                    3 Players
                  </v-card>
                  <v-card
                    v-bind:class="[
                      playersNumber == '4' ? 'teal accent-4' : 'btn-unSelected',
                    ]"
                    class="col-md-3 col-3 pa-2 btnGrpEnd"
                    dark
                    @click="
                      playersNumber = '4';
                      changePlayersNumber();
                    "
                  >
                    4 Players
                  </v-card>
                </v-row>

                <v-select
                  class="mt-4"
                  :items="tiposJuego"
                  v-model="hoyos"
                  item-text="nombre"
                  item-value="id"
                  @onChange="changeHoyos"
                  label="Tipo de juego"
                  solo
                ></v-select>

                <h4 class="light-blue--text text--darken-4 mt-n5">
                  2. Selecciona la fecha de tu juego
                </h4>
                <datepicker
                  @selected="selectDate"
                  :inline="true"
                  :value="input_date.format('MM/DD/YYYY')"
                  :disabled-dates="disabledDates"
                  :highlighted="highlighted"
                ></datepicker>
                <div class="ui card fluid d-none d-sm-flex">
                  <div class="content">
                    <div class="header">Reservation includes:</div>
                  </div>
                  <div class="content">
                    <div class="ui bulleted list">
                      <div class="item">Green Fee</div>
                      <div class="item">Shared Golf cart</div>
                      <div class="item">50 practice balls</div>
                      <div class="item">A bottle of water p/p</div>
                      <div class="item">Course close at 6:00 pm</div>
                    </div>
                  </div>
                </div>
              </v-col>
              <!-- end Seccion  fecha reserva y Jugadores -->
              <v-col cols="12" md="8" lg="9">
                <!-- Seccion  tipo de pago si es hotel -->
                <div v-if="isHotel" class="field">
                  <h4>3. Chose a range</h4>

                  <div class="ui buttons" style="width: 100%">
                    <button
                      v-bind:class="{
                        green: typePaid == 1,
                        blue: typePaid != 1,
                      }"
                      class="ui button"
                      type="button"
                      @click="selectPaid(1)"
                    >
                      <b>GOLF INCLUDED</b>
                      <br />
                      <p class="paidDescription">
                        Golf included in hotel reservation
                      </p>
                    </button>
                    <div class="or"></div>
                    <button
                      v-bind:class="{
                        green: typePaid === 2,
                        blue: typePaid !== 2,
                      }"
                      class="ui button"
                      type="button"
                      @click="selectPaid(2)"
                    >
                      GUEST PAID
                      <br />
                      <p class="paidDescription">
                        Golf fee paid by the customer
                      </p>
                    </button>
                  </div>
                </div>
                <!-- end Seccion  tipo de pago si es hotel -->
                <!-- Seccion  codigo Promocional -->
                <div v-if="typePaid === 1">
                  <h4 class="ui dividing header">
                    4. Promotional Code
                    <div
                      v-if="errors.code"
                      class="ui left pointing red basic label"
                    >
                      Promotional code is required
                    </div>
                    <!--<template v-if="errors.code">
                                            <span  class="unavailable" style="color:red;">Promotional code is required </span>
                                    </template> -->
                  </h4>
                  <div class="field">
                    <input
                      type="text"
                      v-model="promotionalCode"
                      name="promotional"
                      placeholder="Promotional code"
                    />
                  </div>
                </div>
                <!-- end Seccion  codigo Promocional -->
                <!-- Seccion horarios -->
                <h4 class="mt-4 light-blue--text text--darken-4">
                  {{ computedStep.stepTime }}. Seleccione un horario disponible
                  <b v-if="isHotel">
                    {{
                      typePaid === 1
                        ? "- (GOLF INCLUDED)"
                        : typePaid === 2
                        ? " - (GUEST PAID)"
                        : ""
                    }}
                  </b>
                  <div
                    v-if="errors.time"
                    class="ui left pointing red basic label"
                  >
                    Select a prefered time
                  </div>
                </h4>
                <h4
                  v-if="playersNumber == 0"
                  style="margin: 10% auto; font-size: 20px; text-align: center"
                  class="pink--text"
                >
                  Select number of players
                </h4>
                <template
                  v-if="(typePaid > 0 || !isHotel) & (playersNumber != 0)"
                >
                  <div v-if="compTarifas.length >= 1">
                    <tabs :key="compIndex">
                      <template v-for="tarifa in compTarifas">
                        <template
                          v-for="(horario, index) in tarifa.HorariosVisibles"
                        >
                          <tab
                            :selected="index == 0"
                            :name="horario.data.Nombre"
                            :key="index"
                          >
                            <div v-if="typePaid === 1">
                              <a
                                style="
                                  background: rgba(
                                    0,
                                    181,
                                    173,
                                    0.37
                                  ) !important;
                                  color: white;
                                  margin-bottom: 2%;
                                "
                                class="ui label"
                              >
                                !</a
                              >
                              Prefered Time for Transportation
                            </div>
                            <v-row class="pa-5">
                              <template v-for="(time, index) in times">
                                <timeCard
                                  v-if="time.tarifaId == horario.internalId"
                                  v-bind:class="{
                                    cardActive: index === selectedPriceIndex,
                                  }"
                                  :showPrice="false"
                                  :showPromoPrice="false"
                                  :time="time.time"
                                  :price="time.precio"
                                  :mnd="time.moneda"
                                  :priceGlobal="time.precioGlobal"
                                  :prefered="time.preferedClass"
                                  :players="playersNumber"
                                  :reservados="time.personas"
                                  :tarifaId="time.tarifaId"
                                  :tarifaDocId="tarifa.id"
                                  :privado="time.privado"
                                  :isAdmin="isAdmin"
                                  :selectedDate="input_date"
                                  :key="index"
                                  @clicked="setSelectedTime"
                                >
                                </timeCard>
                              </template>
                            </v-row>
                          </tab>
                        </template>
                      </template>
                    </tabs>
                  </div>
                </template>
                <!-- end Seccion horarios -->
              </v-col>
            </v-row>
            <!-- end Seccion de datos fecha reserva -->
            <!-- Seccion de datos del cliente -->
            <!-- End Seccion de datos del cliente -->
            <modal
              :color="'light-blue darken-4'"
              v-model="clienDataModal"
              :fullscreen="true"
              :showFooter="false"
              :disableScroll="true"
              title="Confirmacion"
            >
              <div v-show="this.selectedPriceIndex !== ''">
                <div id="dataCliente" class="">
                  <div class="mb-4">
                    <h3 v-if="false" style="float: right">
                      <v-btn
                        color="teal accent-4"
                        dark
                        v-if="typePaid == 2 && showAddons"
                        @click="toggleModal"
                        depressed
                      >
                        Add Cart Riders
                      </v-btn>
                    </h3>
                    <h3 class="grey--text text--darken-2">
                      {{ computedStep.stepExtraInfo }}. Verifica tu reserva
                      <div
                        v-if="errors.players"
                        class="ui left pointing red basic label"
                      >
                        Verifica tu reserva
                      </div>
                    </h3>
                  </div>
                  <template v-for="(player, index) in players">
                    <div v-bind:key="index">
                      <v-text-field
                        v-model="player.name"
                        label="Name"
                        class="mt-n4"
                        disabled
                        required
                      ></v-text-field>
                    </div>
                  </template>
                </div>
                <transition name="slide-fade">
                  <h1
                    style="float: right"
                    class="light-blue--text text--darken-4"
                  >
                    Total:${{ grandTotal.total }} USD
                  </h1>
                </transition>
                <v-btn
                  @click="bookNow()"
                  color="teal accent-4"
                  block
                  dark
                  v-if="loadingData == false"
                  depressed
                >
                  Reservar
                </v-btn>
              </div>
            </modal>
            <!-- Modal extra rider -->
            <modal
              v-model="modalOpen"
              title="Extra Riders"
              :showFooter="false"
              :disableScroll="true"
              :color="'light-blue darken-4'"
            >
              <h4>Add Cart Riders to reservation</h4>
              <v-row>
                <v-col md="8">
                  <v-text-field v-model="cartRiderName" label="Cart Rider Name">
                  </v-text-field>
                </v-col>
                <v-col md="4">
                  <v-btn
                    class="ma-2"
                    outlined
                    @click="addCartRider"
                    color="indigo"
                  >
                    Add +{{ addOn.cartRider.Precio }}
                    {{ addOn.cartRider.Moneda }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-list-item
                v-for="(cartRider, index) in cartRiders"
                :key="index"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-text="cartRider.name"
                  ></v-list-item-title>
                  <v-list-item-subtitle>
                    ${{ addOn.cartRider.Precio }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn @click="deleteCartRider(index)" icon>
                    <v-icon color="grey lighten-1"
                      >mdi-close-circle-outline</v-icon
                    >
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-btn class="ma-2" color="success" @click="modalOpen = false">
                Confirmar
              </v-btn>
            </modal>
            <!-- end Modal extra rider -->
          </form>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
//const $ = require('jquery');
//window.$ = $;
import modal from "../MainComponents/modal.vue";
import transportacionEP from "../MainComponents/TransportacionEP.vue";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import timeCard from "../MainComponents/timeCardV2.vue";

import FBAxios from "../../helpers/firebaseAxios";
import tarifaMixin from "@/mixins/tarifaMixin";

import rvaMixin from "@/mixins/rvaMixin";

export default {
  name: "booking",
  mixins: [tarifaMixin, rvaMixin],
  components: {
    Datepicker,
    timeCard,
    modal,
  },
  data() {
    return {
      nota: "",
      ConfigRva: null,
      clienDataModal: false,
      MainDepartamento: "",
      presentAlert: false,
      loadingTarifas: false,
      tranindx: 1,
      transModal: false,
      input_date: moment(),
      actualDate: moment(),
      roomNumber: "",
      isAdmin: false,
      transportation: false,
      loadingData: false,
      private_reservation: false,
      isPreferedTime: false,
      Session: "",
      ApiToken: "",
      TotalTrans: 0,
      RowId: "",
      DuracionViaje: "",
      rawDuracionViaje: "",
      HtlPickup: "",
      PCGCPickup: "",
      checkAsGuest: false,
      promotionalCode: "",
      selectedTarifa: "",
      compIndex: 0,
      actualListener: "",
      prefered: true,
      RsvaTransId: "",
      // Confirm:"",
      modalOpen: false,
      selectedPriceIndex: "",
      selectedTime: "",
      playersNumber: "1",
      cartRiderName: "",
      addOn: { cartRider: "", golfClub: "", transport: "" },
      hoyos: "",
      players: [
        {
          name: "",
          email: "",
          phone: "",
          golfClub: false,
          side: "right",
          genero: "Man",
          shaft: "regular",
        },
      ],
      tiposJuego: [],
      temporadas: [],
      tarifas: [],
      tarifaGlobal: [],
      times: [],
      reservas: [],
      cartRiders: [],
      daysRules: [],
      Horarios: [],
      comboPlayers: [
        { value: "1", text: "1 Player" },
        { value: "2", text: "2 Player" },
        { value: "3", text: "3 Player" },
        { value: "4", text: "4 Player" },
      ],
      initTime: new moment("06:00", "HH:mm"),
      endTime: new moment("18:00", "HH:mm"),
      configTime: {},
      intervalo: 10,
      errors: {
        time: false,
        players: false,
        code: false,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(moment()),
          //new Date(2020, 0, 17),
          //new Date(2020, 0, 18)
        ],
      },
    };
  },
  props: ["isHotel", "isWeb"],
  methods: {
    init() {
      this.getTiposJuego()
        .then(() => {
          return this.getTemporadas();
        })
        .then(async () => {
          await this.getHorarios();
          this.getAddons();
          this.getDaysRules();
        });
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    addCartRider() {
      if (this.cartRiderName !== "") {
        this.cartRiders.push({ name: this.cartRiderName });
        this.cartRiderName = "";
        if (this.transportation) {
          this.getTransportationData();
        }
      } else {
        this.$swal({
          icon: "error",
          title: "Cart Rider Name is required",
          text: "",
        });
      }
    },
    deleteCartRider(index) {
      this.cartRiders.splice(index, 1);
      //this.getTransportationData();
    },
    changePlayersNumber() {
      this.presentAlert = false;
      this.resetSelect();
      //this.players= [{name:'',email:'',phone:'',golfClub:false,side:"right",genero:'Man',shaft:'regular'}];
      if (this.players.length < this.playersNumber) {
        var i;
        for (i = this.players.length; i < this.playersNumber; i++) {
          this.players.push({
            name: "",
            email: "",
            phone: "",
            golfClub: false,
            side: "right",
            genero: "Man",
            shaft: "regular",
          });
        }
      } else if (this.players.length > this.playersNumber) {
        for (i = this.playersNumber; i < this.players.length; i) {
          this.players.pop();
        }
      }
      if (this.transportation) {
        this.getTransportationData();
      }
    },
    changeTrans(value) {
      //this.transportation = value;
      if (value == true) {
        this.transModal = true;
      } else {
        /*if(this.selectedPriceIndex === ""){
                    this.$swal(
                        'Selecciona un horario',
                        'Selecciona un horario de juego antes de solicitar transportacion ',
                        'error'
                    )
    
                    document.getElementsByName('trans').forEach((element =>{
                        element.checked = false;
                    }))
            }else if(this.transportation && this.selectedPriceIndex !== ""){
                if(this.isHotel){
                    this.getTransportationData();
                }
                
            }*/
        this.Session = "";
        this.ApiToken = "";
        this.TotalTrans = 0;
        this.RowId = "";
        this.RsvaId = "";
        this.DuracionViaje = "";
        this.HtlPickup = "";
        this.PCGCPickup = "";
        //this.Confirm ="";
        this.transportation = value;
        this.tranindx++;
        /*this.$swal(
                    'No se transportara a los jugadores',
                    'La transportacion al campo de golf  no sera incluida en esta reserva ',
                    'error'
                )*/
      }
    },
    changeHoyos() {
      this.resetSelect();
      (this.selectedTime = ""), (this.selectedPrice = ""), this.compIndex++;
      this.getTarifas();
    },
    changeAsGuest() {
      var $this = this;
      if (this.checkAsGuest) {
        var pNumber = 1;
        this.players.forEach(function (element, index) {
          if (index != 0 && element.name == "") {
            element.name = "Guest " + pNumber;
            element.email = "guest@guestmail.com";
            pNumber++;
          }
        });
      } else {
        this.players.forEach(function (element, index) {
          if (index != 0) {
            element.name = "";
            element.email = "";
          }
        });
      }
    },
    showPrefered() {
      this.resetSelect();
      if (this.prefered) {
        /* this.times.forEach((element)=>{
                       element.prefered = false;
               });*/
        this.times.forEach((element, index) => {
          if (element.personas > 0 && element.prefered == true) {
            this.times[index - 1].preferedClass = true;
            element.preferedClass = true;
            this.times[index + 1].preferedClass = true;
          }
        });
      } else if (this.prefered === false) {
        this.times.forEach((element) => {
          element.preferedClass = true;
        });
      }
    },
    setSelectedTime(key, time, idTarifa, prefered) {
      //alert(key + ' ' + time + ' ' + total);

      this.selectedPriceIndex = key;
      this.selectedTime = time;
      this.selectedTarifa = idTarifa;
      this.isPreferedTime = prefered;
      this.clienDataModal = true;
      this.$nextTick(() => {
        //document.getElementById("dataClient").scrollIntoView();
      });
    },
    selectDate(arg) {
      //let oldDate= this.input_date.format('YYYY-MM-DD');
      //this.killListener(oldDate);
      if (this.playersNumber == 0) {
        this.presentAlert = true;
      }
      this.loadingTarifas = true;
      this.input_date = moment(arg);
      this.resetSelect();
      (this.selectedTime = ""), (this.selectedPrice = ""), this.getTarifas();
    },
    setInitialDate() {
      this.input_date.format("YYYY-MM-DD");
      let aux = false;
      this.daysRules.forEach((element) => {
        if (element.data.Abre && element.data.Cierra) {
          if (this.input_date.format("YYYY-MM-DD") === element.date) {
            this.initTime = new moment(element.data.Abre, "HH:mm:ss");
            this.endTime = new moment(element.data.Cierra, "HH:mm:ss");
            aux = true;
          }
        }
      });
      if (!aux) {
        this.initTime = this.configTime.initTime;
        this.endTime = this.configTime.endTime;
      }
    },
    killListener(date) {
      this.$store.getters.getFirebaseApp.database.ref("Reservas/" + date).off();
    },
    selectPaid(value) {
      this.$store.commit("setTypePaid", value);
      this.getTarifas();
    },
    resetSelect() {
      this.selectedPriceIndex = "";
      this.isPreferedTime = false;
      document.getElementsByName("trans").forEach((element) => {
        element.checked = false;
      });
      this.$store.commit("setPriceSelected", 0);
      this.$store.commit("setMndSelected", "");
    },

    async getTarifas() {
      let idTemporada = "";
      let temporadasAplicables = [];
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          idTemporada = element.id;
          temporadasAplicables.push(element.id);
        }
      });
      let TarifasList = [];
      let taskTarifas = temporadasAplicables.map(async (id) => {
        let tarifas = await this.getMixTarifasByTarifarioParse(
          "WEB",
          id,
          this.MainDepartamento,
          this.Horarios,
          this.temporadas,
          this.tiposJuego,
          this.input_date.day()
        );
        if (tarifas[0]) {
          this.tarifas = [tarifas[0]];
        }

        let tarifasGlobal = await this.getMixTarifasByTarifarioParse(
          "GLOBAL",
          id,
          this.MainDepartamento,
          this.Horarios,
          this.temporadas,
          this.tiposJuego,
          this.input_date.day()
        );
        tarifasGlobal.forEach((tarifa) => {
          if (tarifa.Subcategoria.includes(this.tarifas[0].Subcategoria[0])) {
            this.tarifaGlobal = [tarifa];
          }
        });
      });

      await Promise.all(taskTarifas).then(() => {});

      /*let tarifas = await this.getMixTarifasByTarifarioParse(
            "WEB",
            idTemporada,
            this.MainDepartamento,
            this.Horarios,
            this.temporadas,
            this.tiposJuego,
            this.input_date.day()
          );
          this.tarifas = [tarifas[0]];
    
          let tarifasGlobal = await this.getMixTarifasByTarifarioParse(
            "GLOBAL",
            idTemporada,
            this.MainDepartamento,
            this.Horarios,
            this.temporadas,
            this.tiposJuego,
            this.input_date.day()
          );
          tarifasGlobal.forEach((tarifa) => {
            if (tarifa.Subcategoria.includes(this.tarifas[0].Subcategoria[0])) {
              this.tarifaGlobal = [tarifa];
            }
          });*/

      await this.getReservas();
      this.buildTimesData();
      this.loadingTarifas = false;

      /*
           
    
            if(this.isWeb){
                arrayAccess.push('Web');
            }
            
            this.$store.getters.getFirebaseApp.firebase.collection("Golf_Tarifas")
            //.where('TipoJuego.Id','==',this.hoyos)
            .where('Temporadas',"array-contains",idTemporada)
            .where("Activo", "==", true)
            //.where('Accesos','array-contains-any',arrayAccess)
            .where("Tenant","==",this.$store.getters.getFirebaseApp.tenant).get().then(snapshot=>snapshot.docs.map(doc=>{return {Id:doc.ref.id,...doc.data()}})).then(tarifas=>{
                
                let task = tarifas.map(async(tarifa)=>{
                    let tarifaTemporda = await this.$store.getters.getFirebaseApp.firebasedoc(`Golf_Tarifas/${tarifa.Id}/Temporadas/${this.selectedTemporada}`).where("Tenant","==",this.$store.getters.getFirebaseApp.tenant).get();
                    tarifa.preciosTemporada =  {Id:tarifaTemporda.ref.id,...tarifaTemporda.data()};
                    return tarifa;
                });
             
                return Promise.all(task);
                
        
            }).then((tarifas)=>{
                
               this.tarifas =[];
                var aux = 1;
                let tarifasArray = [];
                tarifas.forEach((element)=>{
                   
                    element.id = aux;
                    
                   
                    let arrayHorarios =  Object.entries(element.preciosTemporada.Horarios);
                    
                    arrayHorarios.forEach((horario)=>{
                        
                        let accesso = '';
     
                        if(element.Id === "WEB"){
                            accesso = "Web";
                        }else if(element.Id === "GLOBAL"){
                            accesso = "Global";
                        }else{
                             accesso = element.Accesos[0];
                        }
    
                        let tipo_juego = Object.entries(horario[1].TiposJuego);
    
                        tipo_juego.forEach((juego)=>{
                            let tarifaObj = {}
                       
                            tarifaObj.id = aux;
                            aux++;
                            tarifaObj.Id = horario[0];
                            tarifaObj.Accesos = [accesso];
                            tarifaObj.Temporada= {}
                            tarifaObj.Temporada.Nombre = element.Nombre
                            tarifaObj.EsPrecioHotel = element.EsPrecioHotel;
                            tarifaObj.Horario = horario[1];
                            tarifaObj.TipoJuego = {};
                            tarifaObj.TipoJuego.Id =juego[0];
                            tarifaObj.TipoJuego.Nombre = juego[1].Nombre;
                            tarifaObj.Moneda = juego[1].Moneda;
                            tarifaObj.Precio =juego[1].Precio;
                            tarifasArray.push(tarifaObj);
    
                        });
                       
                        
                        
                    });
                });
    
                tarifasArray.sort(function compare( a, b ) {
                    return moment(a.Horario.HoraInicio,'HH:mm') - moment(b.Horario.HoraInicio,'HH:mm');
                });
    
                //this.tarifas = tarifasArray;
    
                this.$uvHelper.log(tarifasArray);
               
    
               
    
               
            });*/
    },
    async getHorarios() {
      //const data = await this.$store.getters.getFirebaseApp.database.ref("Golf/Tarifas/Horarios").once("value");
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Horarios")
        .once("value");

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    getServicesIncludes() {},
    async testRealTime() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("Configuracion/Reservas/EmailCCO")
        .once("value");
      this.$uvHelper.log(data.val());
    },
    async getTransportationData() {
      /* 
            Obiene la informacion de la transportacion para la reserva
            */
      let data = {
        PaxNumber: this.players.length + this.cartRiders.length,
        hotelCode: this.$route.params.user.tokenResult.claims.Code,
        Prefered: this.isPreferedTime,
        Fecha:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
      };
      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-transportationAvailability');
      return await this.$store.getters.getFirebaseApp.fba
        .call("Golf-Reservas-transportationAvailability", data, {})
        .then((result) => {
          this.Session = result.data.data.Session;
          this.ApiToken = result.data.data.ApiToken;
          this.TotalTrans =
            this.typePaid === 1
              ? this.playersNumber >= 4
                ? 0
                : this.addOn.transport.Precio
              : this.playersNumber >= 2
              ? 0
              : this.addOn.transport.Precio;
          this.RowId = result.data.data.RowId;
          this.RsvaTransId = result.data.data.RsvaTransId;
          this.rawDuracionViaje = result.data.data.DuracionViaje;
          this.DuracionViaje = moment(
            result.data.data.DuracionViaje,
            "HH:mm:ss"
          ).format("HH [Hrs] : mm [Min].");
          this.HtlPickup = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          this.PCGCPickup = moment(
            result.data.data.PCGCPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          //this.Confirm= result.data.data.Confirm;
          this.loadingData = false;
        })
        .catch((error) => {
          this.$uvHelper.log(error);
        });
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Modalidades")
        .once("value");
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
        if (element[1]["Codigo"] == "18HOLES") {
          this.hoyos = element[0];
        }
      });
    },
    async getTemporadas() {
      /*
             Obtiene las temporadas existentes en la db
            */
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Tarifas/" + this.MainDepartamento + "/Temporadas")
        .once("value");
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        if (element[1].Activo) {
          this.temporadas.push({ id: element[0], ...element[1] });
        }
      });
    },
    async getAddons() {
      /*
             Obtiene las temporadas existentes en la db
            */
      let addons = this.$store.getters.getRVACatalogo;
      /*const dataExt = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/ExtraRidder").once("value");
            let arrayExt =  dataExt.val();*/
      this.addOn.cartRider = addons.GOLFRIDDER; //arrayExt;

      /*const dataGb = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/GolfClub").once("value");
            let arrayGb =  dataGb.val();*/
      this.addOn.golfClub = addons.GOLFCLUB; //arrayGb;

      /*const dataTr = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/Transport").once("value");
            const arrayTr = await dataTr.val();*/
      this.addOn.transport = addons.TRANSPORT;
      /*arrayTarifas.forEach((element)=>{
               this.temporadas.push({id:element[0],...element[1]}); 
            });
    
            const dataGb = await this.$store.getters.getFirebaseApp.database.ref("Addons/GolfClub").once("value");
            let arrayTarifas =  Object.entries(data.val());
            arrayTarifas.forEach((element)=>{
               this.temporadas.push({id:element[0],...element[1]}); 
            });*/
    },
    async getReservas() {
      /*
                Se obtiene las disponibilidad por dia y la cantidad de personas reservadas en esos dias
            */
      let date = this.input_date.format("YYYY-MM-DD");
      this.killListener(this.actualListener);

      this.$store.getters.getFirebaseApp.database
        .ref("RVA/Reservas/" + this.MainDepartamento + "/" + date)
        .on("value", (snapshot) => {
          if (snapshot.exists()) {
            this.reservas = [];

            let arrayReservas = snapshot.val();
            arrayReservas = Object.entries(arrayReservas[1]);
            arrayReservas.forEach((element) => {
              this.reservas.push({ time: element[0], ...element[1] });
            });
          } else {
            this.reservas = [];
          }

          this.buildTimesData();
          this.showPrefered();
        });

      this.actualListener = date;
    },
    async getDaysRules() {
      this.$store.getters.getFirebaseApp.database
        .ref("RVA/Configuracion/" + this.MainDepartamento + "/Calendario")
        .on("value", (snapshot) => {
          if (snapshot.exists()) {
            this.daysRules = [];

            if (snapshot.val().Fechas_Especiales) {
              let arrayCalendar = Object.entries(
                snapshot.val().Fechas_Especiales
              );
              arrayCalendar.forEach((element) => {
                this.daysRules.push({ date: element[0], data: element[1] });
              });

              //ordena las reglas por fecha
              this.daysRules.sort(function compare(a, b) {
                return a.date - b.date;
              });
              //si la fecha inicial esta entre las reglas como un dia cerrado aumenta un dia
              this.daysRules.forEach((element) => {
                if (
                  element.date == this.input_date.format("YYYY-MM-DD") &&
                  element.data == false
                ) {
                  this.input_date.add(1, "days");
                }
              });
              // si es un lunes, verificar si en las reglas abre , si no aumentar un dia
              /*if (this.input_date.weekday() === 1) {
                    let abre = false;
                    this.daysRules.forEach((element) => {
                      if (
                        element.date == this.input_date.format("YYYY-MM-DD") &&
                        element.data == true
                      ) {
                        abre = true;
                      }
                    });
    
                    if (abre == false) {
                      this.input_date.add(1, "days");
                    }
                  }*/

              this.configTime.initTime = new moment(
                snapshot.val().Hora_Apertura,
                "HH:mm:ss"
              );
              this.configTime.endTime = new moment(
                snapshot.val().Hora_Cierre,
                "HH:mm:ss"
              );
            } else {
              this.configTime.initTime = new moment(
                snapshot.val().Hora_Apertura,
                "HH:mm:ss"
              );
              this.configTime.endTime = new moment(
                snapshot.val().Hora_Cierre,
                "HH:mm:ss"
              );
              this.daysRules = [];
            }
          } else {
            this.daysRules = [];
          }
          this.getTarifas();
        });
    },
    buildTimesData() {
      /*
                Genera el array conteniendo cada horario disponible para reserva en un intervalo de 10 minutos desde la hora inicial y la hora final
            */
      this.initTime = "";
      this.endTime = "";
      this.setInitialDate();
      let initTim = new moment(this.initTime.format("HH:mm"), "HH:mm");
      let endTime = new moment(this.endTime.format("HH:mm"), "HH:mm");

      let auxDate = initTim;
      this.times = [];

      var i;
      /*para cada uno de los horarios armados se asignan los datos necesarios*/
      for (i = 0; auxDate.format("HH:mm") <= endTime.format("HH:mm"); i++) {
        var idTarifa;
        let precio = null;
        var moneda;
        var idTarifaGlobal = "";
        var precioGlobal = "";
        let personas = 0;
        let privado = false;
        let prefered = false;
        /* Se asigna la tarifa y el precio */
        this.tarifas.forEach((tarifa) => {
          tarifa.arrayPrecios.forEach((modalidad) => {
            modalidad.horarios.forEach((horario) => {
              if (modalidad.id == this.hoyos) {
                if (
                  horario.data.HoraInicio <= auxDate.format("HH:mm:ss") &&
                  horario.data.HoraTermino >= auxDate.format("HH:mm:ss")
                ) {
                  idTarifa = horario.internalId;
                  precio = horario.PcoVen;
                  moneda = horario.Moneda;
                }
              }
            });
          });
        });
        /*Se asigna la tarifa global y el precio global*/
        this.tarifaGlobal.forEach((tarifa) => {
          tarifa.arrayPrecios.forEach((modalidad) => {
            modalidad.horarios.forEach((horario) => {
              if (modalidad.id == this.hoyos) {
                if (
                  horario.data.HoraInicio <= auxDate.format("HH:mm:ss") &&
                  horario.data.HoraTermino >= auxDate.format("HH:mm:ss")
                ) {
                  idTarifaGlobal = horario.internalId;
                  precioGlobal = horario.PcoVen;
                }
              }
            });
          });
        });

        /*en caso de que tengan reservas en ese Horario y dia seleccionado se agregan a los datos*/
        this.reservas.forEach((element) => {
          let time = new moment(element.time, "HH:mm:ss");
          if (time.format("HH:mm") == auxDate.format("HH:mm")) {
            let rvs = element.Rvs ? element.Rvs : {};
            let rvsArray = Object.entries(rvs);
            rvsArray.forEach((res) => {
              if (res[1].Pys) {
                res[1].Pys.forEach((ply) => {
                  if (ply.E == "R" || ply.E == "P") {
                    personas++;
                  }
                });
              }
            });
            if (this.isHotel) {
              prefered = element.Prefered ? true : false;
            } else {
              prefered = false;
            }
            privado = element.Privado ? element.Privado : false;
          }
        });
        if (!precio) {
          privado = true;
        }
        /* se agregan al array*/
        this.times.push({
          time: auxDate.format("HH:mm"),
          tarifaId: idTarifa,
          tarifaIdGlobal: idTarifaGlobal,
          precioGlobal: precioGlobal,
          precio: precio,
          moneda: moneda,
          personas: personas,
          privado: privado,
          prefered: prefered,
        });
        auxDate = auxDate.add(10, "minutes");
      }
    },
    validation() {
      var valid = true;

      if (this.selectedPriceIndex === "") {
        valid == false;
        this.errors.time = true;
      } else {
        this.errors.time = false;
      }
      let aux = 0;
      this.players.forEach((element) => {
        if (element.name == "" || element.email == "") {
          aux++;
        }
      });

      if (aux > 0) {
        valid = false;
        this.errors.players = true;
      } else {
        this.errors.players = false;
      }

      if (this.typePaid === 1 && this.promotionalCode === "") {
        valid = false;
        this.errors.code = true;
      } else {
        this.errors.code = false;
      }

      return valid;
    },
    buildReservationData() {
      this.players.forEach((element, index) => {
        let tarifa = this.$uvHelper.getById(
          this.tarifas,
          "id",
          this.selectedTarifa
        );
        let tarifaName = "";
        let categoriaId = null;
        let categoriaName = null;
        tarifa.Subcategoria.forEach((element) => {
          categoriaId = element;
          categoriaName = this.$uvHelper.getById(
            this.subcategorias,
            "id",
            element
          ).Nombre;
          tarifaName +=
            this.$uvHelper.getById(this.subcategorias, "id", element).Nombre +
            " ";
        });
        tarifa.cateTarifa = {
          id: categoriaId,
          nombre: categoriaName,
        };
        tarifa.arrayPrecios.forEach((modalidad) => {
          modalidad.horarios.forEach((horario) => {
            if (modalidad.id == this.hoyos) {
              if (
                horario.data.HoraInicio <=
                  moment(this.selectedTime, "HH:mm").format("HH:mm:ss") &&
                horario.data.HoraTermino >=
                  moment(this.selectedTime, "HH:mm").format("HH:mm:ss")
              ) {
                this.players[index].TarifaSelected = {
                  Tarifa: tarifa,
                  Nombre: "WEB",
                  Turista: tarifa.Turista || false,
                  Color: tarifa.Color || null,
                  TarifaId: tarifa.id,
                  Horario: horario,
                  horarioNombre: horario.data.Nombre,
                  Precio: horario.PcoVen,
                  PrecioCon: horario.PcoCon,
                  Moneda: horario.Moneda,
                };
                this.$forceUpdate();
              }
            }
          });
        });
      });

      let resData = this.buildRVAData({
        Tipo: "Golf",
        Cliente: this.players[0],
        Players: this.players,
        Familia: this.ConfigRva?.Contabilidad?.Familia,
        Estatus: "Confirmed",
        Privado: false,
        FechaInicial:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
        Total: this.grandTotal,
        Prepagado: this.typePaid === 1 ? true : false,
        Notas: this.nota,
        Departamento: this.MainDepartamento,
        Tags: ["GOLF"],
        Creador: this.isWeb ? "Web" : "ProShop",

        Modalidad: this.$uvHelper.getById(this.tiposJuego, "id", this.hoyos),
        CartRiders: this.cartRiders,
        Addons: this.Addons,
        Transportacion: null,
        Mayorista: null,
      });

      return resData;
    },
    async getConfig() {
      const conf = await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Configuracion/Golf")
        .once("value");
      let resultConf = conf.val();
      this.ConfigRva = resultConf;
    },
    bookNow() {
      let validation = this.validation();
      if (validation) {
        let reservationData = this.buildReservationData();

        this.$swal({
          title: "Book now?",
          text: "You will not be able to modify your reservation later",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Book now!",
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            //var addReserva = this.$store.getters.getFirebaseApp.fba.call('RVA-Reservas-crearReserva');
            return await this.$store.getters.getFirebaseApp.fba
              .call("RVA-Reservas-crearReserva", reservationData)
              .then(function (result) {
                return result;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.data.ok) {
              let transReservation = "";
              if (result.value.data.data.Transportacion) {
                transReservation =
                  "Transportation number:" +
                  result.value.data.data.Transportacion.Confirmacion;
              }

              this.$swal({
                title: "Reserved",
                text:
                  "Your reservation is done, we send an email with reservation info.    Reservation No. " +
                  result.value.data.data.Folio +
                  " " +
                  transReservation,
                icon: "success",
              }).then(() => {
                if (this.isWeb) {
                  if (this.$store.getters.getFirebaseApp.tenant == "PCUN") {
                    location.href = "https://www.puertocancun.com/";
                  }
                } else {
                  this.$emit("changeIndex");
                }
              });

              this.$emit("changeIndex");
            } else {
              this.$swal(
                "Error saving reservation",
                result.value.data.error,
                "error"
              );
            }
          }
        });
      }
    },
    setTransData(data) {
      this.Session = data.Session;
      this.ApiToken = data.ApiToken;
      this.TotalTrans = data.TotalTrans;
      this.RowId = data.RowId;
      this.RsvaTransId = data.RsvaTransId;
      this.rawDuracionViaje = data.DuracionViaje;
      this.DuracionViaje = moment(data.DuracionViaje, "HH:mm:ss").format(
        "HH [Hrs] : mm [Min]."
      );
      if (data.typeTransportation == 1) {
        this.HtlPickup =
          data.HtlPickup.format(" DD-MMM-YYYY ") +
          moment(data.htime).format("HH [Hrs] : mm [Min].");
        this.PCGCPickup =
          data.PCGCPickup.format(" DD-MMM-YYYY ") +
          moment(data.gtime).format("HH [Hrs] : mm [Min].");
      } else if (data.typeTransportation == 2) {
        this.HtlPickup =
          data.HtlPickup.format(" DD-MMM-YYYY ") +
          moment(data.htime).format("HH [Hrs] : mm [Min].");
        this.PCGCPickup = "NA";
      } else if (data.typeTransportation == 3) {
        this.HtlPickup = "NA";
        this.PCGCPickup =
          data.PCGCPickup.format(" DD-MMM-YYYY ") +
          moment(data.gtime).format("HH [Hrs] : mm [Min].");
      } else if (data.typeTransportation == 4) {
        this.HtlPickup =
          data.HtlPickup.format(" DD-MMM-YYYY ") +
          data.HtlPickup.format("HH [Hrs] : mm [Min].");
        this.PCGCPickup =
          data.PCGCPickup.format(" DD-MMM-YYYY ") +
          data.PCGCPickup.format("HH [Hrs] : mm [Min].");
      }

      this.transportation = true;
      this.transModal = false;
    },
  },
  computed: {
    showAddons() {
      if (this.$store.getters.getFirebaseApp.tenant == "PCUN") {
        return true;
      }
      return false;
    },
    showPromoPrice() {
      if (this.$store.getters.getFirebaseApp.tenant == "PCUN") {
        return true;
      }
      return false;
    },
    showPrice() {
      return true;
    },
    Addons() {
      /*
             Obtiene las temporadas existentes en la this.$store.getters.getFirebaseApp.database
            */
      let AddOn = {};
      let addons = this.$store.getters.getRVACatalogo;
      /*const dataExt = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/ExtraRidder").once("value");
            let arrayExt =  dataExt.val();*/
      AddOn.cartRider = addons.GOLFRIDDER; //arrayExt;

      /*const dataGb = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/GolfClub").once("value");
            let arrayGb =  dataGb.val();*/
      AddOn.golfClub = addons.GOLFCLUB; //arrayGb;

      /*const dataTr = await this.$store.getters.getFirebaseApp.database.ref("Golf/Addons/Transport").once("value");
            const arrayTr = await dataTr.val();*/
      AddOn.transport = addons.TRANSPORT;
      AddOn.roundGolf = addons.GOLFROUND;
      /*arrayTarifas.forEach((element)=>{
               this.temporadas.push({id:element[0],...element[1]}); 
            });
            
            const dataGb = await this.$store.getters.getFirebaseApp.database.ref("Addons/GolfClub").once("value");
            let arrayTarifas =  Object.entries(data.val());
            arrayTarifas.forEach((element)=>{
               this.temporadas.push({id:element[0],...element[1]}); 
            });*/
      return AddOn;
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },
    compTarifas() {
      let compTarifas = [];
      this.tarifas.forEach((tarifa) => {
        let HorarioAplicable = [];
        tarifa.arrayPrecios.forEach((modalidad) => {
          modalidad.horarios.forEach((horario) => {
            if (modalidad.id == this.hoyos) {
              if (this.showAll) {
                this.$uvHelper.log("mostrar todos");
                HorarioAplicable.push(horario);
              } else {
                if (
                  moment(
                    this.input_date.format("YYYY-MM-DD") +
                      horario.data.HoraTermino,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format("YYYY-MM-DD HH:mm:ss") >
                  this.actualDate.format("YYYY-MM-DD HH:mm:ss")
                ) {
                  if (
                    moment(
                      this.input_date.format("YYYY-MM-DD") +
                        this.initTime.format("HH:mm:ss"),
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("YYYY-MM-DD HH:mm:ss") <
                    moment(
                      this.input_date.format("YYYY-MM-DD") +
                        horario.data.HoraTermino,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("YYYY-MM-DD HH:mm:ss")
                  ) {
                    HorarioAplicable.push(horario);
                  }
                }
              }
            }
          });
        });
        tarifa.HorariosVisibles = HorarioAplicable;
        compTarifas.push(tarifa);
      });
      return compTarifas;
    },
    tiposCambio() {
      let cambio = this.$store.getters.getTiposCambios;
      return cambio[0];
    },
    grandTotal() {
      /* calcula el total de la reserva, segun el tipo de pago y los items seleccionados */
      let total = 0;
      let totalPesos = 0;
      let Moneda = this.$store.getters.getMndSelected;
      let montoTarifa =
        this.$store.getters.getPriceSelected != ""
          ? this.$store.getters.getPriceSelected
          : 0;
      total += parseInt(this.TotalTrans);
      if (Moneda == "USD") {
        total += montoTarifa;
        totalPesos += montoTarifa * this.tiposCambio.TC.USD;
      } else if (Moneda == "MXN") {
        total += montoTarifa / this.tiposCambio.TC.USD;
        totalPesos += montoTarifa;
      }
      if (this.typePaid === 1) {
        total = 0;
        totalPesos = 0;
      }
      this.players.forEach((element) => {
        if (element.golfClub) {
          if (this.addOn.golfClub.Moneda == "USD") {
            total += this.addOn.golfClub.Precio;
            totalPesos += this.addOn.golfClub.Precio * this.tiposCambio.TC.USD;
          } else {
            total += this.addOn.golfClub.Precio / this.tiposCambio.TC.USD;
            totalPesos += this.addOn.golfClub.Precio;
          }
        }
      });
      this.cartRiders.forEach(() => {
        if (this.addOn.cartRider.Moneda == "USD") {
          total += this.addOn.cartRider.Precio;
          totalPesos += this.addOn.cartRider.Precio * this.tiposCambio.TC.USD;
        } else {
          total += this.addOn.cartRider.Precio / this.tiposCambio.TC.USD;
          totalPesos += this.addOn.cartRider.Precio;
        }
      });

      return { total: total, totalPesos: totalPesos };
    },
    computedStep() {
      let step = 3;
      let stepExtraInfo = 4;
      if (this.isHotel) {
        if (this.typePaid == 2) {
          step = 4;
          stepExtraInfo = 5;
        } else if (this.typePaid == 1) {
          step = 5;
          stepExtraInfo = 6;
        } else if (this.typePaid == "") {
          step = 4;
          stepExtraInfo = 5;
        }
      }

      return { stepTime: step, stepExtraInfo: stepExtraInfo };
    },
    disabledDates() {
      let disable_dates = [];
      let open_dates = [];

      this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
        } else {
          open_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
        }
      });
      let dataDisable = {
        to: new Date(moment().subtract(1, "days")),

        dates: disable_dates,
        customPredictor: function (date) {
          let aux = true;
          let dateFormat =
            date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
        },
      };
      if (this.$store.getters.getFirebaseApp.tenant == "TNTO") {
        dataDisable.from = new Date(moment().add(60, "days"));
      }
      return dataDisable;
    },
  },
  mounted() {
    this.showPrefered();
    this.playersNumber = 1;
    this.players[0].name = this.$route.params.nombre;
    //this.testRealTime();
  },
  beforeMount() {
    this.MainDepartamento = "Golf";

    this.getConfig();
    this.$store.dispatch("listenerTiposCambio");
    if (this.isHotel) {
      this.prefered = true;
    }
    if (this.isWeb) {
      this.$store.commit("setTypePaid", 2);
    }

    if (!this.isWeb && !this.isHotel) {
      this.$store.commit("setTypePaid", 2);
      this.isAdmin = true;
    }

    this.$store.commit("setGlobalPrice", 190);
    this.init();
  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
};
</script>

<style>
.btn-unSelected {
  background: transparent !important;
}
.btnGrpStart {
  border-radius: 4px 0px 0px 4px !important;
  border: solid 1px white !important;
}
.btnGrpEnd {
  border-radius: 0px 4px 4px 0px !important;
  border: solid 1px white !important;
}
.btnGrpMiddle {
  border-radius: 0px !important;
  border: solid 1px white !important;
}
.vdp-datepicker__calendar .cell.selected {
  background: #00bfa5 !important;
  color: white !important;
}
.no-padding {
  padding-bottom: 0px;
  padding-top: 0px;
}
.containerPlayers {
  padding: 5px;
  border: 1px solid #ff0000 !important;
  border-radius: 5px;
}
@media only screen and (max-width: 600px) {
  .paidDescription {
    display: none !important;
  }
}
.vdp-datepicker__calendar {
  width: 100% !important;
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 768px) {
  .paidDescription {
    display: none !important;
  }
}
</style>
